import React, { useState } from 'react'
import { TextField,Box } from '@mui/material'
import { toast } from 'react-toastify'
import { auth } from '../firebaseconfig'
 const Signupform = ({handleclose}) => {
    const[email,setemail]=useState('')
    const[password,setpassword]=useState('')
    const[Confirmpassword,setConfirmpassword]=useState('')

    const handleSubmit =()=>{
        if(!email || !password || !Confirmpassword)
        {
            toast.warn(' All Fields mandatory!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                });
            return
        }
        if(password !== Confirmpassword){
            toast.error('password mismatch!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                });
            return
        }
        auth.createUserWithEmailAndPassword(email,password).then((res)=>{
            toast.success('User created!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                });
                handleclose()
        }).catch((err)=>{
            toast.error('User creation failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                });
        })
        
    }
    
  return (
    <div><Box p={3}
    style={{display:'flex',
    flexDirection:'column',
    gap:'20px',
    color:'black'

}}
>
    <TextField type='email' 
                variant='outlined' 
                label='Enter email' 
                InputLabelProps={{style:{color:'white'}}} 
                InputProps={{style:{color:'white'}}} 
                onChange={(e)=>setemail(e.target.value)
            }
                />

    <TextField type='password' 
                variant='outlined' 
                label='Enter password' 
                InputLabelProps={{style:{color:'white'}}} 
                InputProps={{style:{color:'white'}}} 
                onChange={(e)=>setpassword(e.target.value)}
                />
    <TextField type='password' 
                variant='outlined' 
                label='Confirm password' 
                InputLabelProps={{style:{color:'white'}}} 
                InputProps={{style:{color:'white'}}}
                onChange={(e)=>{setConfirmpassword(e.target.value)}}
                />
    <button variant='contained' 
            size='large' 
            onClick={handleSubmit}
            style={{background:'dodgerblue'}}>
            Signup
            </button>
</Box>
</div>
  )
}
export default Signupform